import { render, staticRenderFns } from "./SubdomainModal.vue?vue&type=template&id=4dc16870&scoped=true&"
import script from "./SubdomainModal.vue?vue&type=script&lang=js&"
export * from "./SubdomainModal.vue?vue&type=script&lang=js&"
import style0 from "./SubdomainModal.vue?vue&type=style&index=0&id=4dc16870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc16870",
  null
  
)

export default component.exports